import { render, staticRenderFns } from "./ComponenteDialogo.vue?vue&type=template&id=2849fc74&scoped=true&"
import script from "./ComponenteDialogo.vue?vue&type=script&lang=ts&"
export * from "./ComponenteDialogo.vue?vue&type=script&lang=ts&"
import style0 from "./ComponenteDialogo.vue?vue&type=style&index=0&id=2849fc74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2849fc74",
  null
  
)

export default component.exports